import { useState, useEffect } from "react";
import Config from "../../Config";


import InputDate from "../../helpers/InputDate";
import InputText from "../../helpers/InputText";
import InputBankAccount from "../../helpers/InputBankAccount";
import InputCombo from "../../helpers/InputCombo";
import InputDecimal from "../../helpers/InputDecimal";
import InputTime from "../../helpers/InputTime";
import { UNSAFE_DataRouterStateContext } from "react-router-dom";
import InputSearchEmp from "../../helpers/InputSearchEmp";

import edit from "../../edit.png";
import generate from "../../generate.pdf";
import BkTextEditor from "../../BkTextEditor/BkTextEditor";
import InputTextArea from "../../helpers/InputTextArea";


function ContractTemplateEdit(props)
{    


    const defRow = {
            id: props.row.id,
            nazwa: props.row.nazwa,          
            tresc: props.row.tresc,                               
    };


    const [view, setView] = useState('btn');    
    const [errTab, setErrTab] = useState([]);  //z info od serwera..
    const [row, setRow] = useState(defRow);

    
     const [txtPDF, setTxtPDF] = useState(defRow.tresc);


     const [itemSelected, setItemSelected] = useState(1);


      const clickTab = (e) => {

        var t = e.target.getAttribute("atr-tab");
        setItemSelected(t);

        if(t == 3) getPDFPreper();
    }


    const [pdfB64, setPDFB64] = useState(null);
 

    const valChangeListener = (filedName, val, correct, msg) => {

 
        console.log("valChangeListener: " + filedName + " " + val + ", correct: " + correct + ", msg: " + msg);     
        setRow( {...row, [filedName]:val,  [filedName+"_valid"]:correct } );         
    }


       //zmiana w tresci..
    const valChangeListenerTxt = (filedName, val, correct, msg) => {         
            setTxtPDF(val);
    }


    const goNextNew = () => {
        console.log("goNext");
        saveData();
    }

    const valChecker = (fields) => {

        var allValid = true;

              
        Object.entries(fields).forEach(function(entry) {

            var xKey    = entry[0];
            var xValue  = entry[1];

            var xValidName = xKey + "_valid";

            if(fields[xValidName] == false)
            {
                allValid = false;
                console.log("Error field: " + xKey);
            }
            
          });
        
          return allValid;

    }



    const saveData = () => {


 
 


        if(!valChecker(row))
        {
            props.mainView.showDialog(props.userData.dic.dlg_notice_wrong , props.userData.dic.dlg_gocorrect  ,  "ok"  ,null); 
            return;
        }


        
        if(row.nazwa.length < 2) 
            {
                props.mainView.showDialog(props.userData.dic.dlg_notice_wrong , 'Podaj nazwę' ,  "ok"  ,null); 
                return; 
            }
 
 
        props.mainView.setProgress(-2);

        var req =  {
            id: row.id,
            nazwa: row.nazwa,
            txt: txtPDF,
        };


        fetch( Config.url + '/rest_v1_calc,szablony_update', {
            method: 'POST', 
            body: JSON.stringify(req), 
            headers: {
                'Content-Type': 'application/json',                    
                'X-Api-Key': props.userData.apiKey,
                '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                '_p_dziecko_id_': props.userData.p_dziecko_id,
                '_sec_key_': Config.genXKey() ,
            }
         })
         .then(res => res.json() )
         .then(res => { 

                    changeView();

                    props.mainView.setProgress(-1);        
                    if(res._sys_ == undefined)
                    {
                        props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                    }else
                    if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                    {
                        props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                    }else    
                    {
                       props.mainView.showDialog( "Sukces",  "Pozycja została dodana" , "ok" , null);    
                       if(props.onUpdated != undefined) props.onUpdated(res.result);
                    }
         } )
         .catch(err => {          
                    props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
                    props.mainView.setProgress(-1);
         });
                   

         return false;

    }



   

    const getPDFPreper = () => {
       

        setPDFB64(null);
       
        //var txtPre = preperText(txtPDF, false);
        var txtPre = txtPDF;
        
        
        props.mainView.setProgress(-2);

        var req = {
                html: txtPre,
                orientation: "portrait",
                title: "Szablon " + row.nazwa
        };

        fetch(  Config.master + '/rest_v1,html_to_pdf', {
            method: 'POST', 
            body: JSON.stringify(req), 
            headers: {
                          
                'X-Api-Key': props.userData.apiKey,
                '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                '_p_dziecko_id_': props.userData.p_dziecko_id,
                '_sec_key_': Config.genXKey() ,
            }
         })
         .then(res => res.json() )
         .then(res => { 

                    props.mainView.setProgress(-1);        
                    if(res._sys_ == undefined)
                    {
                        props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                    }else
                    if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                    {
                        props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                    }else    
                    {
                     // var decodedString = atob(res.result.b64);           
                    //  setStream(res.result.b64);   

                        setPDFB64(res.result.b64);
                    
                    //    let pdfWindow = window.open("");
                    //    pdfWindow.document.write("<html<head><title>"+ row.nazwa +"</title><style>body{margin: 0px;}</style></head>");
                    //    pdfWindow.document.write("<body><embed width='100%' height='100%' src='data:application/pdf;base64, " + encodeURI(res.result.b64)+"#toolbar=0&navpanes=0&scrollbar=0'></embed></body></html>");
                    //    pdfWindow.document.close();

                    }
         } )     
         .catch(err => {          
                    props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
                    props.mainView.setProgress(-1);
         });
                   

         return false;
    }



 const getPDF = () => {
       

        setPDFB64(null);
       
        //var txtPre = preperText(txtPDF, false);
        var txtPre = txtPDF;
        
        
        props.mainView.setProgress(-2);

        var req = {
                html: txtPre,
                orientation: "portrait",
                title: "Szablon " + row.nazwa
        };

        fetch(  Config.master + '/rest_v1,html_to_pdf', {
            method: 'POST', 
            body: JSON.stringify(req), 
            headers: {
                          
                'X-Api-Key': props.userData.apiKey,
                '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                '_p_dziecko_id_': props.userData.p_dziecko_id,
                '_sec_key_': Config.genXKey() ,
            }
         })
         .then(res => res.json() )
         .then(res => { 

                    props.mainView.setProgress(-1);        
                    if(res._sys_ == undefined)
                    {
                        props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                    }else
                    if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                    {
                        props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                    }else    
                    {
                     // var decodedString = atob(res.result.b64);           
                    //  setStream(res.result.b64);   

                     
                       let pdfWindow = window.open("");
                       pdfWindow.document.write("<html<head><title>"+ row.nazwa +"</title><style>body{margin: 0px;}</style></head>");
                    pdfWindow.document.write("<body><embed width='100%' height='100%' src='data:application/pdf;base64, " + encodeURI(res.result.b64)+"#toolbar=0&navpanes=0&scrollbar=0'></embed></body></html>");
                         pdfWindow.document.close();

                    }
         } )     
         .catch(err => {          
                    props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
                    props.mainView.setProgress(-1);
         });
                   

         return false;
    }


    const changeView = () => {
        if(view == 'btn') {setView("dlg"); }  else setView('btn');

       
        setRow(defRow);
    }   




    var cssTab1 = "";
    var cssTab2 = "";
    var cssTab0 = "";
    var cssTab3 = "";

    if(itemSelected == 0) cssTab0 = " xActive ";
    if(itemSelected == 1) cssTab1 = " xActive ";
    if(itemSelected == 2) cssTab2 = " xActive ";    
    if(itemSelected == 3) cssTab3 = " xActive ";    
 


    var dlg_view =  (

        <div className="dlg_window dlg_type_xx shadowx">

                <div className="dlg_title">
                     Edycja szablonu
                </div>


                <div className="dlg_content_x">


                            <div className="form_tab">
            
                                    <div className="form_control">
                                        <div className="fieldName">Nazwa własna szablonu* </div>
                                        <InputText   userData={props.userData} value={row.nazwa} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="nazwa" placeholder={"Nazwa: np. Zajęcia sportowe, angielski, ..."} className=' w300 ' req='1' firstUp="1" />
                                    </div>
                                                             
                            </div>
 
                            



                                <div className="form_tab">

                                        <div className="xTabs">
                                            <div className={"xItem " + cssTab0 } atr-tab="0" onClick={clickTab}  >Wyrażenia</div>
                                            <div className={"xItem " + cssTab1 } atr-tab="1" onClick={clickTab}  >Edytor</div>
                                            <div className={"xItem " + cssTab2 } atr-tab="2" onClick={clickTab}  >HTML</div>                                                                                                    
                                            <div className={"xItem " + cssTab3 } atr-tab="3" onClick={clickTab}  >PDF</div>                                                                                                    
                                            <div className={"xEmpty "  }>&nbsp;</div>
                                        </div>

                                        {
                                            itemSelected == 0 &&
                                                       <div className="form_tab">
                                                                <div className="scroll200">
                                                                        <ul>
                                                                            <li>@logo</li>
                                                                            <li>@numer_umowy, numer umowy</li>
                                                                            <li>@data_zawarcia, data zawarcia umowy</li>
                                                                            <li>@miejsce_zawarcia_umowy, miejsce zawarcia umowy</li>
                                                                            <li>@data_od, data początkowa umowy</li>
                                                                            <li>@data_do, data zakończenia umowy</li>
                                                                            <li>@nazwa_przedszkola, nazwa placówki bez danych adresowych</li>
                                                                            <li>@imie_nazwisko_rodzica_1,</li>
                                                                            <li>@imie_nazwisko_rodzica_2</li>
                                                                            <li>@adres_rodzica_1, </li>
                                                                            <li>@adres_rodzica_2,  </li>
                                                                            <li>@email_rodzica_1, </li>
                                                                            <li>@email_rodzica_2, </li>
                                                                            <li>@telefon_rodzica_1, </li>
                                                                            <li>@telefon_rodzica_2, </li>
                                                                            <li>@numer_dowodu_rodzic_1, </li>
                                                                            <li>@numer_dowodu_rodzic_2, </li>
                                                                            <li>@numer_pesel_rodzic_1, </li>
                                                                            <li>@numer_pesel_rodzic_2, </li>
                                                                            <li>@imie_nazwisko_dziecka,  </li>
                                                                            <li>@pesel_dziecka,  </li>
                                                                            <li>@data_urodzenia_dziecka, </li>
                                                                            <li>@miejsce_zamieszkania_dziecka, </li>
                                                                            <li>@miejsce_zameldowania_dziecka, </li>
                                                                            <li>@miejsce_urodzenia_dziecka,  </li>                                       
                                                                        </ul>
                                                                </div>
                                                            </div>
                                        }  

                                        {
                                            itemSelected == 1 &&
                                                <div className="">
                                                        <div className="form_control">                                                                                                                 
                                                            <BkTextEditor  name="tresc" valChange={valChangeListenerTxt}  value={txtPDF} mini="1"  req='1' refresh={1}  /> 
                                                        </div>
                                                </div> 
                                        }

                                        {
                                            itemSelected == 2 &&
                                            <div className="">
                                                  <div className="">                                                  
                                                    <InputTextArea   userData={props.userData} value={txtPDF} err={errTab}  valChange={valChangeListenerTxt} goNext={null} name="tresc" placeholder={""} className=' p100 h300  ' req='1' firstUp="0" />
                                                </div>
                                            </div>
                                        }
                                        
                                        {
                                            itemSelected == 3 &&
                                            <div>
                                                    {
                                                        pdfB64 == null &&
                                                        <div>
                                                             <iframe src={generate}  height="400px" width="100%"></iframe>
                                                        </div>
                                                    }

                                                    {
                                                        pdfB64 != null &&
                                                        <div>
                                                            <iframe src={"data:application/pdf;base64,"+pdfB64}  height="400px" width="100%"></iframe>
                                                            <br/>
                                                            &nbsp;
                                                            <br/>
                                                            <div className="link_color" onClick={getPDF}>pokaż widok PDF</div>
                                                        </div>
                                                    }
                                            </div>
                                        }

                                                                               

                                    </div>

                                    <br/>


                                    <div className="form_control">                                            
                                     
                                        &nbsp; &nbsp;  
                                        <div className="btn" onClick={saveData}>zapisz</div>
                                        &nbsp; &nbsp;
                                        <div className="btn" onClick={changeView}>anuluj</div>
                                                                           
                                    </div>

                </div>

            
        </div>
);

if(view == 'btn') dlg_view = null;


return  <div>              
            <img  onClick={changeView}  className="ibtn" src={edit} title="Zmień dane"    />  
            {dlg_view} 
       </div>


}


export default ContractTemplateEdit;